import React, { useState, useEffect } from "react";
import {
  Button,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import { UploadResults } from "../components";
import __ from "utils/i18n";
import { tenantId as staticTenantId } from "config/envConfig";

const ImportResultsStep = ({
  uploadOk,
  results,
  subsidiaryId,
  token,
  navigation,
  hideModal,
  resetModal,
  onCampaignSubscribe,
  onCampaignConfirmed,
  onConfirmSuccess,
  onCampaignReset,
  fileName,
  hasActiveCampaign,
}) => {
  const [importConfirmed, setImportConfirmed] = useState(false);
  const [canImport, setCanImport] = useState(false);
  const [campaignUuid, setCampaignUuid] = useState(null);

  useEffect(() => {
    const resolvedId =
      results?.data?.campaignUuid ||
      results?.data?.campaign_id ||
      results?.campaignUuid ||
      results?.campaign_id ||
      null;

    setCampaignUuid(resolvedId);
  }, [results]);

  const handleNewImport = () => {
    resetModal();
    if (typeof onCampaignReset === "function") {
      onCampaignReset();
    }
    navigation.go(0);
  };

  const handleBackdropClose = () => {
    hideModal();
  };

  const handleImport = () => {
    setImportConfirmed(true);
  };

  const handleStartEmailSending = (eventData) => {
    if (typeof onCampaignConfirmed !== "function") {
      return;
    }

    const fallbackTenant =
      eventData?.tenantId ||
      results?.tenantId ||
      results?.tenantIdentifier ||
      results?.tenant_identifier ||
      subsidiaryId ||
      staticTenantId ||
      null;

    if (eventData && typeof eventData === "object") {
      const effectiveUuid = eventData.campaignUuid || campaignUuid;
      onCampaignConfirmed({
        campaignUuid: effectiveUuid,
        totalRegisters:
          eventData.totalRegisters ??
          results?.successful ??
          results?.totalProcessed ??
          0,
        fileName: eventData.fileName ?? fileName,
        tenantId: fallbackTenant,
      });
      return;
    }

    const effectiveUuid = eventData || campaignUuid;
    if (!effectiveUuid) {
      return;
    }

    onCampaignConfirmed({
      campaignUuid: effectiveUuid,
      totalRegisters: results?.successful || results?.totalProcessed || 0,
      fileName,
      tenantId: fallbackTenant,
    });
  };

  return (
    <div className="import-modal import-modal-results">
      <ModalHeader toggle={handleBackdropClose}>
        {__("dashboard.sections.massivePaymentLink.import.title")}
      </ModalHeader>

      <ModalBody>
        <UploadResults
          uploadOk={uploadOk}
          results={results}
          subsidiaryId={subsidiaryId}
          token={token}
          onCampaignSubscribe={onCampaignSubscribe}
          onCampaignConfirmed={handleStartEmailSending}
          onCampaignReset={onCampaignReset}
          fileName={fileName}
            onImportConfirmed={() => {
              setImportConfirmed(true);
              if (typeof onConfirmSuccess === "function") {
                onConfirmSuccess();
              }
            }}
          onCanImportChange={setCanImport}
          triggerImport={importConfirmed && canImport}
          hideModal={hideModal}
        />
      </ModalBody>

      <div className="modal-separator">
        <hr />
      </div>

      <ModalFooter>
        {hasActiveCampaign && (
          <div className="mr-auto text-warning small">
            Ya tenés una campaña en proceso. Esperá a que finalice para enviar otra.
          </div>
        )}
        {!uploadOk && (
          <Button color="secondary" onClick={handleNewImport}>
            {__("dashboard.sections.massivePaymentLink.modals.buttons.newImport")}
          </Button>
        )}

        {uploadOk && !importConfirmed && canImport && (
          <>
            <Button color="secondary" onClick={handleNewImport}>
              {__("dashboard.sections.massivePaymentLink.modals.buttons.newImport")}
            </Button>
            <Button
              color="primary"
              onClick={handleImport}
              disabled={hasActiveCampaign}
            >
              {__("dashboard.sections.massivePaymentLink.import.button")}
            </Button>
          </>
        )}
      </ModalFooter>
    </div>
  );
};

export default ImportResultsStep;
